const config = {
  appVersion: '1.3.1',
  closeSurveyPin: '7586',
  localApiHost: 'https://api-app.diagmatic.pl',
  apiUrl: 'api',
};

export default config;
